import { ComponentStyleConfig } from '@chakra-ui/react';
import type { StyleFunctionProps, SystemStyleObject } from '@chakra-ui/theme-tools';
import { mode } from '@chakra-ui/theme-tools';

import { getElevatedShadow } from 'theme/shadows';

const Toolbar: ComponentStyleConfig = {
  baseStyle: (props: StyleFunctionProps): SystemStyleObject => ({
    display: 'inline-flex',
    '& > *:not(style) ~ *:not(style)': {
      marginStart: 0
    },
    padding: '2px',
    borderRadius: '8px',
    bg: mode('silver.lightest', 'black.lighter')(props),
    boxShadow: getElevatedShadow(props),
    button: {
      boxShadow: 'none',
      bg: 'none',
      _hover: { bg: mode('silver.lighter', 'black.lightest')(props) },
      _active: { bg: mode('silver.light', 'grey.base')(props) },
      borderRadius: '6px'
    },
    divider: {
      bg: mode('silver.lightest', 'black.lighter')(props)
    }
  }),
  variants: {
    ghost: {
      boxShadow: 'none',
      bg: 'none',
      button: {
        borderRadius: '8px'
      }
    }
  }
};

export default Toolbar;
